import { CellProps, Row } from 'src/components/DataTable/types';

type PodRowWithExpectedVersion = {
  imageVersion: string;
  expectedVersion?: string[];
};

function PodVersionCell({ item, value }: CellProps<any, Row>) {
  const row = item as unknown as PodRowWithExpectedVersion;
  const hasBaseline = !!row?.expectedVersion?.length;
  const mismatch = hasBaseline && !row.expectedVersion!.includes(value);

  let color: string | undefined;
  if (mismatch) {
    color = '#D32F2F'; // confirmed mismatch
  } else if (!hasBaseline) {
    color = '#ED6C02'; // no baseline available to verify against
  }

  return (
    <span style={color ? { color, fontWeight: 500 } : undefined}>{value}</span>
  );
}

export default PodVersionCell;
